import React from "react";
import styles from "./blueprint-table-header.module.scss";
import { useI18N } from "@src/language/language-context";

const cssClassName = "blueprint-table-header";

export const BlueprintTableHeader = () => {
  const i18n = useI18N();
  return (
    <thead className={styles[`${cssClassName}`]}>
      <tr className={styles[`${cssClassName}__table-header-row`]}>
        <th className={styles[`${cssClassName}__table-header-cell`]}>
          {i18n("modules.blueprintsTable.tableHeader.blueprintName")}
        </th>
        <th className={styles[`${cssClassName}__table-header-cell`]}>
          {i18n("modules.blueprintsTable.tableHeader.updateDate")}
        </th>
        <th className={styles[`${cssClassName}__table-header-cell`]}>
          {i18n("modules.blueprintsTable.tableHeader.author")}
        </th>
        <th className={styles[`${cssClassName}__table-header-cell`]}>
          {i18n("modules.blueprintsTable.tableHeader.organization")}
        </th>
      </tr>
    </thead>
  );
};
